import React, { useEffect, useState } from "react";
import { getAllCitiesEffect } from "../../../appRedux/admin/Doctor/sagas/effects/doctorEffect";
import DoctorSelectBox from "./DoctorSelectBox";

const CitySelector = ({
  placeholder = "Select City",
  label = "",
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  StateId,
  value = "",
  defaultValue
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getStatusList(StateId);
  }, [StateId]);

  const getStatusList = async (StateId) => {
    try {
      const { data } = await getAllCitiesEffect(StateId);
      const cityList = data?.data;
      let options = cityList.map((row) => ({
        label: row.cityName,
        value: row.cityName,
        id: row.id,
      }));

      console.log("City option", options);
      setOptions(options);
    } catch (error) {
      setOptions([]);
    }
  };

  return (
    <DoctorSelectBox
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      defaultValue={defaultValue}
    />
  );
};

export default CitySelector;
